import { useCallback, useMemo } from 'react';
import { combineStatus } from 'commons/utils/combineStatus';
import { convertStatusTypeToObject } from 'commons/utils/convertStatusTypeToObject';
import { useGetScheduledPlanDowngradeQuery } from 'domains/Billing/Checkout/CheckoutApi/checkoutApi';
import { useBillingPlans } from './useBillingPlans';

export function usePlanDowngrade(initialFetch = true, getPlansData = true) {
  const {
    data,
    status: downgradeStatus,
    refetch: refreshDowngradeData,
  } = useGetScheduledPlanDowngradeQuery(undefined, { skip: !initialFetch });
  const {
    currentPlan,
    plansList,
    status: plansStatus,
    fetchBillingPlans: refreshPlans,
  } = useBillingPlans(initialFetch && getPlansData);

  const { status } = combineStatus(downgradeStatus, plansStatus);

  const newPlan = useMemo(
    () =>
      plansList.find(({ id }) => id === data?.scheduledDowngrade?.newPlanId),
    [plansList, data],
  );

  const retryLoad = useCallback(() => {
    refreshDowngradeData();
    refreshPlans();
  }, [refreshDowngradeData, refreshPlans]);

  return {
    scheduledDowngrade: data?.scheduledDowngrade,
    status,
    oldPlanName: currentPlan?.name,
    newPlanName: newPlan?.name,
    currentPlan,
    newPlan,
    newPlanId: data?.scheduledDowngrade?.newPlanId,
    retryLoad,
    ...convertStatusTypeToObject(status),
  };
}
